<template>
  <div class="text-center text-muted my-5 py-5">
    <IconArrowAutofitLeft :size="200" stroke-width="0.5" style="color: #d9e3ea"></IconArrowAutofitLeft>
    <br />
    <IconArrowLeft></IconArrowLeft> {{ $t('promptsuite.empty_hint') }}
  </div>
</template>

<script setup lang="ts">
import { IconArrowAutofitLeft, IconArrowLeft } from '@tabler/icons-vue';
</script>
